import Dashboard from '../containers/dashboard'
import PaymentMovementsManagement from '../containers/payment-movements-management'

const PaymentMovements = () => {
  return (
    <Dashboard>
      <PaymentMovementsManagement />
    </Dashboard>
  )
}

export default PaymentMovements
